<template>
  <q-layout view="hHh Lpr fFf" class="overflow-hidden bg-[#fafbfb]">
    <main class="page-container">
      <div class="container-base">
        <!-- <OButtonBack class=" mt-24" /> -->
      </div>
      <router-view></router-view>
    </main>
    <ModalAtencao ref="modalAtencaoRef" />
    <ModalParametros ref="modalParametrosRef" />
    <DevTricksCards v-if="DEV" />
  </q-layout>
</template>

<script setup>
import { Dark } from 'quasar'
import { DEV } from 'js/utils/constants/dev'
import { lang } from 'store/lang.store'
import { loadLocaleMessages } from '../i18n'
import { onMounted, provide, ref } from 'vue'
import { params } from 'store/params.store'
import { useI18n } from 'vue-i18n'
import { useSessionStorage, useUrlSearchParams } from '@vueuse/core'
import DevTricksCards from 'components/Dev/DevTricksCards.vue'
import ModalAtencao from 'components/Modal/ModalAtencao.vue'
import ModalParametros from 'components/Modal/ModalParametros.vue'
import OButtonBack from 'components/Button/OButtonBack.vue'
import OSelectLang from 'components/Select/OSelectLang.vue'
import useIframeParams from 'composables/useIframeParams'

const modalAtencaoRef = ref(null)
const modalParametrosRef = ref(null)

// Seta o locale de acordo com o lang
const { locale } = useI18n({ useScope: 'global' })

loadLocaleMessages(lang.value)

locale.value = lang.value

Dark.set(false)
useIframeParams()

provide('modal', {
  modalAtencaoRef,
  modalParametrosRef,
})
</script>

<style lang="sass" scoped></style>
